import { createContext, useContext, useEffect, useState } from "react"
//import { sideBarByRoleId } from "../services/sideBar";
import { GetState,GetDisease,GetProduct } from "../services/orderService";
const AppDataContext = createContext();
export const AppDataProvider = ({ children }) => {
    //const [menuData, setMenuData] = useState([]);
    const[diseases,setDiseases]=useState([]);
    const[state,setState]=useState([]);
    const[product,setProduct]=useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    // const roleId = localStorage.getItem("roleid");
    // alert(roleId);
    useEffect(() => {
        const loadMasterData = async () => {
            try {
                const [
                    diseasesResponse,
                    stateResponse,
                    productResponse,
                ] = await Promise.all([
                    GetDisease(),
                    GetState(),
                    GetProduct(),
                ]);
                setState(stateResponse.data || []);
                setProduct(productResponse.data || []);
                setDiseases(diseasesResponse.data ||[]);
            }
            catch (err) {
                console.log(err);
                setError("Failed to load data")
            } finally {
                setLoading(false);
            }

        };
        loadMasterData();
    }, []);
    return (
        <AppDataContext.Provider
            value={{ 
                state,
                product,
                diseases,
                loading,
                error,
             }}
        >
            {children}
        </AppDataContext.Provider>
    );
};
export const useAppData = () => useContext(AppDataContext);